import React from "react";
import TitleIcon from '@mui/icons-material/Title';
import ColorLensIcon from '@mui/icons-material/ColorLens';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import VisibilityIcon from '@mui/icons-material/Visibility';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Slider from '@mui/material/Slider';

interface Props {
  setActiveOverlay?: (overlay: string) => void;
}

const UploadSettingsSidebar: React.FC<Props> = ({ setActiveOverlay }) => {
  return (
    <>
      <div className="editor_card">
        <h3>Overlays</h3>
        <div className="overlay_tabs">
          <figure className="tab_btn" onClick={() => setActiveOverlay?.('text')}>
            <TitleIcon sx={{ fontSize: 20 }} />
            <figcaption>Text</figcaption>
          </figure>
          <figure className="tab_btn" onClick={() => setActiveOverlay?.('color')}>
            <ColorLensIcon sx={{ fontSize: 20 }} />
            <figcaption>Color</figcaption>
          </figure>
          <figure className="tab_btn active">
            <img src="/static/images/upload.svg" alt="color_upload_icon" />
            <figcaption>Upload</figcaption>
          </figure>
        </div>
      </div>

      <div className="editor_card layout_setting">
        <h3>Layout Setting</h3>
        <div className="file_card">
          <img src="/static/images/avtar.svg" alt="family_photo" className="thumb" />
          <div className="file_info">
            <strong>Family_photo.jpg</strong>
            <span>1200 x 1200 px &bull; 2.4 MB</span>
          </div>
          <button className="del_btn">
            <DeleteOutlineIcon sx={{ fontSize: 16 }} />
          </button>
        </div>

        <div className="position_control">
          <span>Position</span>
          <div className="control_body">
            <div className="position_grid">
              <span className="dot"></span>
              <span className="dot"></span>
              <span className="dot"></span>
              <span className="dot"></span>
              <span className="dot active"></span>
              <span className="dot"></span>
              <span className="dot"></span>
              <span className="dot"></span>
              <span className="dot"></span>
            </div>
            <div className="coord_inputs">
              <div className="coord_row">
                <span>X</span>
                <div className="dropdown">
                  <span>1024 px</span>
                  <KeyboardArrowDownIcon className="arrow" />
                </div>
              </div>
              <div className="coord_row">
                <span>Y</span>
                <div className="dropdown">
                  <span>1024 px</span>
                  <KeyboardArrowDownIcon className="arrow" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="setting_row">
          <div className="setting_header">
            <span>Scale</span>
            <span className="value">68%</span>
          </div>
          <div className="slider_control">
            <Slider className="slider" defaultValue={68} min={0} max={100} />
          </div>
        </div>

        <div className="setting_row">
          <div className="setting_header">
            <span>Rotate</span>
            <span className="value">0&deg;</span>
          </div>
          <div className="slider_control">
            <Slider className="slider" defaultValue={0} min={-180} max={180} />
          </div>
        </div>

        <div className="setting_row">
          <div className="setting_header">
            <span>Opacity</span>
            <span className="value">75%</span>
          </div>
          <div className="slider_control">
            <Slider className="slider" defaultValue={75} min={0} max={100} />
          </div>
        </div>

        <button className="apply_overlay_btn">Apply Overlay</button>
      </div>

      <div className="editor_card">
        <h3>Layers</h3>
        <div className="layers_list">
          <div className="layer_item active_layer">
            <div className="layer_left">
              <span className="micro_img">
                <DragIndicatorIcon sx={{ fontSize: 14 }} />
              </span>
              <img src="/static/images/avtar.svg" alt="" className="thumb" />
              <div className="info">
                <strong>Family Photo</strong>
                <span>Image</span>
              </div>
            </div>
            <div className="layer_right">
              <img src="/static/images/trash.svg" alt="" className="thumb" />

              <VisibilityIcon sx={{ fontSize: 18, color: '#fff', opacity: 0.5 }} />
            </div>
          </div>

          <div className="layer_item">
            <div className="layer_left">
              <span className="micro_img">
                <DragIndicatorIcon sx={{ fontSize: 14 }} />
              </span>
              <img src="/static/images/leaf.svg" alt="" className="thumb" style={{ background: '#222' }} />
              <div className="info">
                <strong>Logo</strong>
                <span>Image</span>
              </div>
            </div>
            <div className="layer_right">
              <img src="/static/images/trash.svg" alt="" className="thumb" />
              <VisibilityIcon sx={{ fontSize: 18, color: '#fff', opacity: 0.5 }} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UploadSettingsSidebar;
